// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2z8KF","topBottomGutter":"Layout_topBottomGutter__8fyZr"};